export enum SessionStorageKeys {
    Timeout = 'timeout',
    ExplorationDefault = 'explorationDefault',
    SnapshotDefault = 'snapshotDefault',
    InsightsFilters = 'insightsFilters',
    UpdateDisplay = 'updateDisplay',
    Message = 'message'
}
